<template>
  <div class="competency-module">
    <img
      v-lazyload
      class="background-image no-right-click"
      :data-src="lockImg"
      alt="背景"
      srcset=""
    />
    <div class="competency-module-top">
      <div v-movein class="competency-title">领先的数据能力服务践行者</div>
      <div v-movein class="competency-description">
        科度持续深耕大数据分析、人工智能、隐私计算等核心技术的应用；为公安、银行、企业提供数据服务和行业应用的解决方案和产品。
      </div>
    </div>
    <div class="competency-module-bottom">
      <div v-movein class="competency-item">
        <CustomerFilledIcon class="item-icon" />
        <div class="item-title">数据服务</div>
        <ul class="description-list">
          <li class="description-item">数据治理服务</li>
          <li class="description-item">数据智能服务</li>
          <li class="description-item">数据应用服务</li>
        </ul>
      </div>
      <div v-movein class="competency-item">
        <FolderSafetyFilledIcon class="item-icon" />
        <div class="item-title">应用产品</div>
        <ul class="description-list">
          <li class="description-item">公安反诈系列产品</li>
          <li class="description-item">银行金融风控产品</li>
          <li class="description-item">企业数据服务产品</li>
        </ul>
      </div>
      <div v-movein class="competency-item">
        <ApplicationFilledIcon class="item-icon" />
        <div class="item-title">行业经验</div>
        <ul class="description-list">
          <li class="description-item">公安10年+深度实践</li>
          <li class="description-item">银行5年+深度实践</li>
          <li class="description-item">多个省平台驻场服务</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import ApplicationFilledIcon from '@/assets/icon/svg/applicationFilled.svg?inline'
import CustomerFilledIcon from '@/assets/icon/svg/customerFilled.svg?inline'
import FolderSafetyFilledIcon from '@/assets/icon/svg/folderSafetyFilled.svg?inline'
import lockImg from '@/assets/images/lock.png'
export default {
  components: {
    ApplicationFilledIcon,
    CustomerFilledIcon,
    FolderSafetyFilledIcon
  },
  data() {
    return {
      lockImg
    }
  }
}
</script>
<style lang="less" scoped>
.competency-module {
  position: relative;
  display: flex;
  display: -ms-flexbox;
  margin: 0 auto;
  max-width: 1200px;
  height: 100vh;
  min-height: 500px;
  -ms-flex-direction: column;
  flex-direction: column;
  -ms-flex-pack: space-between;
  justify-content: space-around;
  -ms-flex-align: center;
  align-items: center;
  .background-image {
    position: absolute;
    top: 48px;
    right: -37px;
    height: 491px;
    max-height: 100%;
    width: auto;
    z-index: 0;
  }
  .competency-module-top {
    position: relative;
    width: 100%;
    .competency-title {
      position: relative;
      font-family: SourceHanSansCN;
      font-weight: 700;
      font-size: 32px;
      line-height: 64px;
      letter-spacing: 0px;
      vertical-align: middle;
      color: transparent;
      background: linear-gradient(
        180deg,
        #ffffff 81.5%,
        rgba(240, 232, 204, 0.4) 100%
      );
      background-clip: text;
      -webkit-background-clip: text;
      text-shadow: 0px 2px 6px #00000014, 0px 6px 2px #0000000f;
      z-index: 1;
    }
    .competency-description {
      position: relative;
      margin-top: 48px;
      max-width: 777px;
      font-weight: 500;
      font-size: 16px;
      line-height: 48px;
      letter-spacing: 0%;
      vertical-align: middle;
      color: #ffeff0;
      z-index: 1;
    }
  }
  .competency-module-bottom {
    position: relative;
    .competency-item {
      float: left;
      margin-right: 24px;
      padding: 40px;
      width: 384px;
      height: 306px;
      background-color: #141414;
      border: 1px solid #262626;
      border-radius: 16px;
      // &:nth-child(even) {
      //   .item-icon {
      //     color: white;
      //   }
      // }
      // &:nth-child(odd) {
      // }
      .item-icon {
        color: #dc143c;
      }
      &:last-child {
        margin-right: 0;
      }
      .item-icon {
        margin: 16px 24px;
        width: 40px;
        height: 40px;
      }
      .item-title {
        padding-top: 24px;
        padding-left: 22px;
        width: 140px;
        font-family: SourceHanSansCN;
        font-weight: 600;
        font-size: 24px;
        line-height: 36px;
        color: #ffffff;
      }
      .description-list {
        margin-top: 16px;
        padding-left: 0;
        font-weight: 500;
        font-size: 16px;
        letter-spacing: 0%;
        color: #ffeff0;
        list-style-type: none;
        .description-item {
          display: flex;
          margin-bottom: 4px;
          height: 24px;
          align-items: center;
          &::before {
            content: '';
            display: block;
            margin-right: 16px;
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background-color: #ffeff0;
          }
        }
      }
    }
  }
}
@media screen and (min-width: 1024.02px) and (max-width: 1200px) {
  .competency-module {
    .background-image {
      right: 0;
    }
    .competency-module-top {
      padding: 0 32px;
    }
    .competency-module-bottom {
      .competency-item {
        width: 320px;
        height: 280px;
        padding: 32px;
        margin-right: 16px;
        .item-icon {
          width: 32px;
          height: 32px;
        }
        .item-title {
          width: 120px;
          font-size: 20px;
          line-height: 24px;
        }
      }
    }
  }
}

@media screen and (min-width: 768.02px) and (max-width: 1024px) {
  /* 中等屏幕样式 */
  .competency-module {
    .background-image {
      right: 0;
    }
    .competency-module-top {
      padding: 0 32px;
      width: 777px;
      .competency-description {
        margin-top: 24px;
      }
    }
    .competency-module-bottom {
      .competency-item {
        width: 230px;
        height: 250px;
        padding: 16px;
        margin-right: 16px;
        .item-icon {
          width: 30px;
          height: 30px;
        }
        .item-title {
          padding-top: 8px;
          font-size: 20px;
          line-height: 24px;
        }
        .description-list {
          font-size: 16px;
        }
      }
    }
  }
}

/* 移动端 */
@media screen and (min-width: 600.02px) and (max-width: 768px) {
  .competency-module {
    .background-image {
      right: 0;
    }
    .competency-module-top {
      padding: 0 32px;
      max-width: 768px;
      .competency-description {
        margin-top: 16px;
      }
    }
    .competency-module-bottom {
      .competency-item {
        width: 190px;
        height: 220px;
        padding: 16px;
        margin-right: 12px;
        .item-icon {
          display: inline-block;
          margin-top: 4px;
          margin-bottom: 12px;
          margin-right: 0;
          width: 24px;
          height: 24px;
        }
        .item-title {
          display: inline-block;
          padding-top: 4px;
          padding-left: 0;
          font-size: 20px;
          line-height: 20px;
        }
        .description-list {
          font-size: 14px;
        }
      }
    }
  }
}

@media screen and (min-width: 480.02px) and (max-width: 600px) {
  .competency-module {
    .background-image {
      right: 0;
    }
    .competency-module-top {
      padding: 0 32px;
      max-width: 768px;
      .competency-description {
        margin-top: 16px;
      }
    }
    .competency-module-bottom {
      width: 100%;
      padding: 0 32px;
      .competency-item {
        position: relative;
        float: none;
        width: 100%;
        height: 140px;
        padding: 0 16px;
        margin-bottom: 12px;
        margin-right: 0;
        &:last-child {
          margin-bottom: 0;
        }
        .item-icon {
          position: relative;
          display: block;
          margin-top: 32px;
          margin-bottom: 12px;
          margin-left: 0;
          margin-right: 0;
          left: 25%;
          width: 32px;
          height: 32px;
          transform: translateX(-50%);
        }
        .item-title {
          display: block;
          padding-top: 4px;
          padding-left: 0;
          width: 50%;
          text-align: center;
          font-size: 20px;
          line-height: 20px;
        }
        .description-list {
          position: absolute;
          margin: 0;
          top: 50%;
          right: 0;
          width: 50%;
          font-size: 14px;
          transform: translateY(-50%);
        }
      }
    }
  }
}

@media screen and (max-width: 480px) {
  .competency-module {
    .background-image {
      right: 0;
      width: 100%;
      height: auto;
    }
    .competency-module-top {
      padding: 0 32px;
      max-width: 768px;
      .competency-title {
        font-size: 30px;
        line-height: 48px;
      }
      .competency-description {
        margin-top: 16px;
        line-height: 36px;
      }
    }
    .competency-module-bottom {
      width: 100%;
      padding: 0 32px;
      .competency-item {
        position: relative;
        float: none;
        width: 100%;
        height: 140px;
        padding: 0;
        margin-bottom: 12px;
        margin-right: 0;
        &:last-child {
          margin-bottom: 0;
        }
        .item-icon {
          position: relative;
          display: block;
          margin-top: 32px;
          margin-bottom: 12px;
          margin-left: 0;
          margin-right: 0;
          left: 20%;
          width: 32px;
          height: 32px;
          transform: translateX(-50%);
        }
        .item-title {
          display: block;
          padding-top: 4px;
          padding-left: 0;
          width: 40%;
          text-align: center;
          font-size: 18px;
          line-height: 20px;
        }
        .description-list {
          position: absolute;
          margin: 0;
          top: 50%;
          right: 0;
          width: 60%;
          font-size: 14px;
          transform: translateY(-50%);
        }
      }
    }
  }
}
</style>
